export type AudioTrack = {
    id: string,
    lang: string,
    isActive: boolean,
    label?: string,
    bitrate?: number
};

export const EmptyAudioTrack: AudioTrack = { id: "", lang: "", label: "", isActive: true };